import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgStyle, NgIf, NgFor, NgClass } from '@angular/common';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
    selector: 'app-itinerary-details',
    templateUrl: './itinerary-details.component.html',
    styleUrls: ['./itinerary-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgStyle, NgIf, NgFor, NgClass]
})
export class ItineraryDetailsComponent implements OnInit {
  @Input() public itineraries: any[] = [];
  @Input() public className: string = '';
  @Input() public isIncludeTableHeader = false;
  @Input() public tourLengthShortName: string = '';
  @Input() public cruiseName: string = '';
  @Input() public isWidthComplete: boolean = false;
  @Input() public isfontSmall: boolean = false;
  @Input() public daysItinerary: string = '';
  @Input() public itineraryDescription: string = '';
  @Input() public itineraryName: string = '';

  constructor(public dataService: DataService) { }

  ngOnInit() { }
  isPair(index: number) {
    return index % 2 === 0 ? true : false;
  }

  addStyleToDescription(description: string): string {
    let desc = description.replace("<ul>", "<ul class='custom-ul'>").split("<li>").join("<li class='custom-li'>");
    return desc;
  }

  getAllActivities(iter: any) {
    const morning = iter.morningActivities?.map((a: any) => ({
      ...a,
      isMorning: true,
    })) || [];

    const afternoon = iter.afternoonActivities?.map((a: any) => ({
      ...a,
      isMorning: false,
    })) || [];

    return [...morning, ...afternoon];
  }
}
